export const translations = {
  en: {
    nav: {
      properties: 'Properties',
      about: 'About',
      services: 'Services',
      neighborhoods: 'Neighborhoods',
      contact: 'Contact',
    },
    hero: {
      eyebrow: 'Coldwell Banker Realty Minnesota',
      headline: 'Cenia Badillo',
      subhead: 'Assisting buyers and sellers for over two decades',
      buyBtn: 'Buy a Home',
      sellBtn: 'Sell My Home',
    },
    marquee: [
      '21+ Years of Experience',
      '1,000+ Homes Sold',
      'Bilingual English and Spanish',
      'Minnesota Licensed Realtor',
      'Coldwell Banker Luxury Specialist',
    ],
    meet: {
      eyebrow: 'Your Minnesota Realtor',
      headline: 'Meet Cenia Badillo',
      body1:
        'With over 21 years of experience and more than 1,000 properties sold across Minnesota, Cenia Badillo has built a reputation for unparalleled expertise, bilingual service, and genuine dedication to every client. Whether you are searching for your dream home or ready to sell, Cenia guides you through every step with honesty, strategy, and care.',
      body2:
        'Con más de 21 años de experiencia y más de 1,000 propiedades vendidas en Minnesota, Cenia Badillo ha construido una reputación de experiencia incomparable, servicio bilingüe y dedicación genuina a cada cliente.',
      cta: "Let's Connect",
    },
    stats: {
      eyebrow: 'Unparalleled Expertise',
      headline: 'By The Numbers',
      items: [
        { num: '21+', label: 'Years of Experience' },
        { num: '1,000+', label: 'Homes Sold' },
        { num: '2', label: 'Languages' },
        { num: '#1', label: 'Priority: You' },
      ],
    },
    services: {
      eyebrow: 'How I Can Help',
      headline: 'My Services',
      cards: [
        {
          title: 'Buying a Home',
          desc: "Expert guidance to find and secure your perfect property in Minnesota's competitive market.",
        },
        {
          title: 'Selling Your Home',
          desc: "Strategic marketing and negotiation to maximize your property's value and ensure a smooth sale.",
        },
        {
          title: 'First-Time Buyers',
          desc: 'Patient, step-by-step support to make your first home buying experience exciting and stress-free.',
        },
      ],
    },
    properties: {
      eyebrow: 'Browse My Listings',
      headline: 'Featured Properties',
      status: 'For Sale',
      viewBtn: 'View Details',
      seeAllBtn: 'See All Properties',
    },
    neighborhoods: {
      eyebrow: 'Areas of Expertise',
      headline: 'Minnesota Neighborhoods',
    },
    testimonials: {
      eyebrow: 'Success Stories',
      headline: 'What My Clients Say',
      quotes: [
        {
          text: 'Excellent help with everything related to buying a home.',
          author: 'Rick Berland',
        },
        {
          text: 'Vendimos nuestra casa en tiempo récord y por encima del precio que esperábamos. Cenia es una profesional increíble.',
          author: 'Familia Rodriguez',
        },
        {
          text: "Professional, attentive, and truly cares about her clients. I wouldn't trust anyone else with my real estate needs.",
          author: 'James L.',
        },
      ],
    },
    work: {
      eyebrow: 'Ready to Begin',
      headline: 'Work With Cenia',
      body: 'Whether you are buying your dream home or selling your property, Cenia Badillo brings 21 years of expertise, bilingual service, and unmatched dedication to every transaction.',
      cta: "Let's Connect",
    },
    contact: {
      eyebrow: 'Get in Touch',
      headline: "Let's Connect",
      form: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        interest: 'I am interested in',
        options: ['Buying', 'Selling', 'First-Time Buyer', 'General'],
        message: 'Message',
        submit: 'Send Message',
      },
    },
    footer: {
      brokerage: 'Coldwell Banker Realty Minnesota',
      quickLinks: 'Quick Links',
      contact: 'Contact',
      social: 'Social',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      rights: '© 2026 Cenia Badillo. All rights reserved.',
    },
  },
  es: {
    nav: {
      properties: 'Propiedades',
      about: 'Acerca de',
      services: 'Servicios',
      neighborhoods: 'Vecindarios',
      contact: 'Contacto',
    },
    hero: {
      eyebrow: 'Coldwell Banker Realty Minnesota',
      headline: 'Cenia Badillo',
      subhead: 'Asistiendo a compradores y vendedores por más de dos décadas',
      buyBtn: 'Comprar Casa',
      sellBtn: 'Vender mi Casa',
    },
    marquee: [
      '21+ Años de Experiencia',
      '1,000+ Casas Vendidas',
      'Bilingüe Inglés y Español',
      'Realtor Licenciada en Minnesota',
      'Especialista en Lujo Coldwell Banker',
    ],
    meet: {
      eyebrow: 'Tu Realtor en Minnesota',
      headline: 'Conoce a Cenia Badillo',
      body1:
        'Con más de 21 años de experiencia y más de 1,000 propiedades vendidas en Minnesota, Cenia Badillo ha construido una reputación de experiencia incomparable, servicio bilingüe y dedicación genuina a cada cliente. Ya sea que estés buscando la casa de tus sueños o listo para vender, Cenia te guía en cada paso con honestidad, estrategia y cuidado.',
      body2:
        'With over 21 years of experience and more than 1,000 properties sold across Minnesota...',
      cta: 'Conectemos',
    },
    stats: {
      eyebrow: 'Experiencia Incomparable',
      headline: 'En Números',
      items: [
        { num: '21+', label: 'Años de Experiencia' },
        { num: '1,000+', label: 'Casas Vendidas' },
        { num: '2', label: 'Idiomas' },
        { num: '#1', label: 'Prioridad: Tú' },
      ],
    },
    services: {
      eyebrow: 'Cómo Puedo Ayudar',
      headline: 'Mis Servicios',
      cards: [
        {
          title: 'Comprar una Casa',
          desc: 'Orientación experta para encontrar y asegurar tu propiedad perfecta en el competitivo mercado de Minnesota.',
        },
        {
          title: 'Vender tu Casa',
          desc: 'Marketing estratégico y negociación para maximizar el valor de tu propiedad y asegurar una venta sin problemas.',
        },
        {
          title: 'Primeros Compradores',
          desc: 'Apoyo paciente paso a paso para hacer que tu primera experiencia de compra sea emocionante y sin estrés.',
        },
      ],
    },
    properties: {
      eyebrow: 'Explora mis Listados',
      headline: 'Propiedades Destacadas',
      status: 'En Venta',
      viewBtn: 'Ver Detalles',
      seeAllBtn: 'Ver Todas las Propiedades',
    },
    neighborhoods: {
      eyebrow: 'Áreas de Especialidad',
      headline: 'Vecindarios de Minnesota',
    },
    testimonials: {
      eyebrow: 'Historias de Éxito',
      headline: 'Lo Que Dicen Mis Clientes',
      quotes: [
        {
          text: 'Excelente ayuda en todo lo relacionado con la compra de casa.',
          author: 'Rick Berland',
        },
        {
          text: 'Vendimos nuestra casa en tiempo récord y por encima del precio que esperábamos. Cenia es una profesional increíble.',
          author: 'Familia Rodriguez',
        },
        {
          text: 'Profesional, atenta y realmente se preocupa por sus clientes. No confiaría en nadie más para mis necesidades inmobiliarias.',
          author: 'James L.',
        },
      ],
    },
    work: {
      eyebrow: 'Lista para Empezar',
      headline: 'Trabaja con Cenia',
      body: 'Ya sea que estés comprando la casa de tus sueños o vendiendo tu propiedad, Cenia Badillo aporta 21 años de experiencia, servicio bilingüe y dedicación incomparable a cada transacción.',
      cta: 'Conectemos',
    },
    contact: {
      eyebrow: 'Ponerse en Contacto',
      headline: 'Conectemos',
      form: {
        name: 'Nombre',
        email: 'Correo Electrónico',
        phone: 'Teléfono',
        interest: 'Estoy interesado en',
        options: ['Comprar', 'Vender', 'Primer Comprador', 'General'],
        message: 'Mensaje',
        submit: 'Enviar Mensaje',
      },
    },
    footer: {
      brokerage: 'Coldwell Banker Realty Minnesota',
      quickLinks: 'Enlaces Rápidos',
      contact: 'Contacto',
      social: 'Redes Sociales',
      privacy: 'Política de Privacidad',
      terms: 'Términos de Servicio',
      rights: '© 2026 Cenia Badillo. Todos los derechos reservados.',
    },
  },
}
